import Immutable from 'immutable';

export function getValidEvents(entity, dates) {
  const now = new Date();
  entity.get('field_events', Immutable.List()).forEach((event, delta) => {
    if (!event.get('entity')) {
      return;
    }

    // Skip if event is full (based on max participants).
    if (event.getIn(['entity', 'amount_of_registrations', 0, 'value']) >= event.getIn(['entity', 'field_maximum_participants', 0, 'value'])) {
      return;
    }

    // Skip if the event is not published.
    if (!event.getIn(['entity', 'status', 0, 'value'])) {
      return;
    }

    // Skip if the event is before today.
    const date = new Date(Date.parse(event.getIn(['entity', 'field_date', 0, 'value'])));
    if (date.getTime() < now.getTime()) {
      return;
    }

    // Skip if the event is not open
    if (event.getIn(['entity', 'field_status', 0, 'value']) !== 'open') {
      return;
    }

    date.setDate(1);
    date.setHours(0, 0, 0);
    const dateString = date.toISOString();

    if (!dates[dateString]) {
      dates[dateString] = [];
    }

    entity = entity.set('delta', delta);
    dates[dateString].push(entity);
  });
  return dates;
}

export const dateCompare = (event1, event2) => {
  const delta1 = event1.get('delta');
  const delta2 = event2.get('delta');
  const date1 = new Date(Date.parse(event1.getIn(['field_events', delta1, 'entity', 'field_date', 0, 'value'])));
  const date2 = new Date(Date.parse(event2.getIn(['field_events', delta2, 'entity', 'field_date', 0, 'value'])));

  if (date1 < date2) {
    return -1;
  } else if (date1 > date2) {
    return 1;
  }
  return 0;
};
